type ColorOption = "red" | "yellow" | "green" | "purple";

const colorMap: Record<ColorOption, string> = {
  red: "#cf314e",
  yellow: "#d2993d",
  green: "#43b29a",
  purple: "#C090BF",
};

export const SectionHeader = ({
  color,
  text,
}: {
  color: ColorOption;
  text: string;
}) => {
  const hexColor = colorMap[color];

  return (
    <div className="flex items-center gap-1 mb-2">
      <div
        className="h-1.5 w-1.5 rounded-full"
        style={{ backgroundColor: hexColor }}
      />
      <h2 className="font-bold" style={{ color: hexColor }}>
        {text}
      </h2>
    </div>
  );
};
